import { activePageActionTypes } from '@constants/actionTypes/ssapActionTypes';

// getInitialState function is introduced to have possibility to test in Jest
// reducer's initial state depending on environment

export const getInitialState = () => {
    const {
        __ENV__: {
            DEVELOPMENT
        } = {}
    } = global;

    return DEVELOPMENT ? -1 : 0;
};

export default (state = getInitialState(), action = {}) => {
    switch (action.type) {
        case activePageActionTypes.CHANGE_PAGE:
            switch(action.page) {
                case 'increase':
                    return state + 1;
                case 'decrease':
                    return state - 1;
                default:
                    if(typeof action.page !== 'number') {
                        throw new Error('Invalid value (not "increase", "decrease" or number) has been passed in activePageReducer');
                    }
                    return action.page;
            }
        case activePageActionTypes.INITIALIZE_SSAP:
            if (action.payload.page !== null && action.payload.page !== undefined) {
                return action.payload.page;
            }
            return state;
        case activePageActionTypes.CLEAR_SSAP_STATE:
            return getInitialState();
        default:
            return state;
    }
};
